module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.nolayout) ? [_c('router-view')] : [_c('Toolbar'), _vm._v(" "), _c('main', {
    staticClass: "ma-0"
  }, [_c('Sidebar'), _vm._v(" "), _c('router-view')], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2284f53c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 59
// module chunks = 8